import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useApi from "../hooks/useApi";
import { useUser } from "../hooks/useUser";
import { gestionaMultiplesArtistas } from "../utils/tiposArtista";
import Landing from "./landing";

// Pantalla de entrada del sitio (radar.freim.tv/).
//
// Con sesión iniciada sigue funcionando como antes: manda a cada usuario a su
// pantalla de trabajo según el rol. Sin sesión ya no redirige al login, sino
// que muestra la landing pública: es la primera cosa que ve alguien que llega
// desde una búsqueda o desde un link compartido, y desde ahí decide si entra
// a registrarse o a iniciar sesión.
function Inicio() {
  const navigate = useNavigate();
  const { loggedApi } = useApi();
  const { user } = useUser();

  useEffect(() => {
    if (!loggedApi) return;

    // Un sello, manager o label no tiene biblioteca de canciones propia: su
    // material cuelga de cada artista, así que su pantalla de trabajo es el
    // roster. Mandarlo a la biblioteca lo dejaba en una lista siempre vacía.
    user.role === "artista" &&
      navigate(
        gestionaMultiplesArtistas(user?.profile?.tipo)
          ? "/artista/roster"
          : "/artista/biblioteca"
      );
    user.role === "productor" && navigate("/productor/envios");
    user.role === "admin" && navigate("/admin/dashboard");
  }, []);

  // Mientras se resuelve la redirección de un usuario con sesión no se pinta
  // la landing, para que no alcance a aparecer un instante antes del salto.
  if (loggedApi) return <></>;

  return <Landing />;
}

export default Inicio;
